document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.featured-section .splide');

    sliders.forEach((slider) => {
        const splide = new Splide(slider, {
            perPage: 4,
            fixedWidth: '213px',
            perMove: 4,
            gap: '2rem',
            type: 'loop',
            pagination: false,
            arrows: true,
            breakpoints: {
                1000: {
                    perPage: 3,
                    perMove: 3,
                },
                800: {
                    perPage: 2,
                    perMove: 2,
                    fixedWidth: '240px',
                },
                500: {
                    gap: '1rem',
                    perPage: 1.5,
                    perMove: 1,
                },
            },
        });

        splide.mount();
    });
});

const filterSelects = document.querySelectorAll('.query-loop--bm_bjui_module .query-loop__filter select');
filterSelects.forEach((filterSelect) => {
    const initialValue = filterSelect.value;
    filterSelect.addEventListener('change', function () {
        if (this.value !== initialValue) {
            this.form.submit();
        }
    });
});